import { useState } from "react";
import { Icon } from "@elaniintc/goes-design-system";
import clsx from "clsx";

export const GripHandle = ({ className = "" }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={clsx(
        "active:bg-neutral-object-accent-quiet active:cursor-grabbing active:text-on-disabled cursor-grab hover:bg-neutral-object-accent-silent hover:text-on-disabled-quiet px-1 py-0 rounded text-on-disabled-quiet transition-colors",
        className,
      )}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <Icon type={hovered ? "fas" : "far"} name="grip-vertical" />
    </div>
  );
};
